<app-storyblok-root
  [story]="story"
  [blurOverlay]="blurOverlay"
  [darkHeader]="darkHeader"
  [hasHomeTeaser]="hasHomeTeaser"
  [prefooter]="prefooter"
  [topBlur]="topBlur"
  [verticalDottedLines]="verticalDottedLines"
  [extraDataMap]="extraDataMap"
></app-storyblok-root>
